<template>
  <div class="dashboard">
    <div class="page-top-section">
      <div class="left">
        <h2>ARTWORKS</h2>
        <div class="page-indication">
          <p>Artworks</p>
          <i class="fa-solid fa-caret-right"></i>
          <p class="active">Artworks List</p>
        </div>
      </div>
      <div class="right">
        <div class="export-btn">
          <button class="btn">
            <i class="fa-solid fa-download"></i>
            <span>Export</span>
          </button>
        </div>
        <div class="add-btn">
          <router-link
            :to="{ name: 'AdminAddArtwork', params: { actionType: 'Add' } }"
            class="btn"
          >
            <i class="fa-solid fa-plus"></i>
            <span>Add Artwork</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="categories-section">
      <div class="categories-left">
        <div class="categories-list">
          <span
            @click="
              filterCategory = 'All';
              filterItems();
            "
            :class="{ active: filterCategory == 'All' }"
            >All Artworks</span
          >
          <span
            @click="
              filterCategory = 'Available';
              filterItems();
            "
            :class="{ active: filterCategory == 'Available' }"
            >Available</span
          >
          <span
            @click="
              filterCategory = 'Sold';
              filterItems();
            "
            :class="{ active: filterCategory == 'Sold' }"
            >Sold</span
          >
        </div>
      </div>
      <div class="categories-right">
        <div class="search">
          <form action="">
            <i class="fa-solid fa-search"></i>
            <input type="text" placeholder="Search artworks. . ." />
          </form>
        </div>
        <div class="dates">
          <i class="fa-solid fa-calendar-days"></i>
          <input type="date" />
        </div>
        <div class="filter-btn">
          <i class="fa-solid fa-filter"></i>
          <span>Filters</span>
        </div>
      </div>
    </div>
    <div class="art-table">
      <table>
        <!-- Artwork, UCI Code, Artist Name, Dimensions, Color, Sales Price, Hammer Price, Status, Creation year, Action -->
        <thead>
          <tr>
            <th class="sm">
              <my-checkbox
                :checked="checkedItems.length > 0"
                @checkNow="checkNow(1)"
                :mainCheckbox="true"
                @UncheckAllNow="checkedItems = []"
                @checkAllNow="checkAllNow()"
              />
            </th>
            <th>Artwork</th>
            <th>Title (ENG)</th>
            <th>Title (KOR)</th>
            <th>Creation Year</th>
            <th>Size</th>
            <th>Ho Size (Only KOR)</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.artwork_id"
            :class="{ active: checkedContains(item.id) }"
          >
            <td class="sm">
              <my-checkbox
                :checked="checkedContains(item.id)"
                @checkNow="checkNow(item.id)"
              />
            </td>
            <td>
              <div class="img">
                <img :src="$uploads(item.artwork_images[0])" alt="" />
              </div>
            </td>
            <td>{{ item.title_eng }}</td>
            <td>{{ item.title_kor }}</td>
            <td>{{ item.creation_year }}</td>
            <td>{{ item.size }}</td>
            <td>{{ item.ho_size_kor }}</td>
            <td>
              <div
                class="status"
                :class="{
                  pending: item.artwork_status_eng == 'Available',
                  cancelled: item.artwork_status_eng == 'Sold',
                }"
              >
                {{ item.artwork_status_eng }}
              </div>
            </td>
            <td>
              <div class="actions">
                <router-link
                  :to="{
                    name: 'AdminEditArtwork',
                    params: { actionType: 'Edit', id: item.artwork_id },
                  }"
                  class="fa-solid fa-pen"
                ></router-link>
                <router-link
                  :to="{
                    name: 'AdminEditArtwork',
                    params: { actionType: 'Edit', id: item.artwork_id },
                  }"
                  class="fa-solid fa-eye"
                ></router-link>
                <i
                  class="fa-solid fa-trash"
                  @click="
                    (e) => {
                      e.preventDefault();
                      selectedItem = item;
                      showDeleteModel = true;
                    }
                  "
                >
                </i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <pagination
        class="pagination"
        :totalItems="allItems.length"
        :itemsPerPage="itemsPerPage"
        @pageChanged="
          (page) => {
            changePage(page);
          }
        "
      />
    </div>
    <confirm-model
      :modelTitle="'Delete Artwork'"
      :displayText="`Are you sure you want to delete ${selectedItem.title_eng}?`"
      :smallModel="true"
      @closeModel="showDeleteModel = false"
      @confirmModel="deleteItem()"
      v-if="showDeleteModel"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      allItems: [
        {
          id: 1,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "red",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 2,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "pink",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 3,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "yellow",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 4,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "Green",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 5,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "Orange",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 6,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "Blue",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 7,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "yellow",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 8,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "black",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 9,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "green",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 10,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "red",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 11,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "#333",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 12,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 13,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200",
          color: "red",
          salesPrice: "N/A",
          hammerPrice: "121.00",
          status: "Available",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
        {
          id: 14,
          artwork: "Monalisa",
          uciCode: "302012",
          artistName: "Leo Da vinci",
          dimensions: "200 W * 160 H * 2 D cm",
          color: "red",
          salesPrice: "590.00",
          hammerPrice: "N/A",
          status: "Sold",
          creationYear: "29 Dec 2000",
          image: "5.jpg",
          location: "Korea",
        },
      ],
      items: [],
      checkedItems: [],
      currentPage: 1,
      itemsPerPage: 10,
      filterCategory: "All",
      selectedItem: {},
      showDeleteModel: false,
    };
  },
  methods: {
    checkedContains(id) {
      return this.checkedItems.includes(id);
    },
    checkNow(id) {
      if (this.checkedItems.includes(id)) {
        this.checkedItems = this.checkedItems.filter((item) => item !== id);
      } else {
        this.checkedItems.push(id);
      }
    },
    checkAllNow() {
      this.checkedItems = [];
      this.items.forEach((item) => {
        this.checkedItems.push(item.id);
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.artWorks = this.$changePage(this.allItems, page, this.itemsPerPage);
      window.scrollTo(0, 0);
    },

    getItems() {
      this.$startLoader();
      this.$store
        .dispatch("GET_ARTWORKS", {
          token: this.$getToken(),
        })
        .then((res) => {
          this.$stopLoader();
          this.allItems = res.data;
          this.allItems.forEach((item) => {
            item.artwork_images = JSON.parse(item.artwork_images);
          });
          this.items = this.$changePage(
            this.allItems,
            this.currentPage,
            this.itemsPerPage
          );
        })
        .catch((err) => {
          this.$stopLoader();
          if (err.response.status == 400) {
            err.response.data.errors.forEach((error) => {
              this.$notify({
                type: "error",
                title: "Something went wrong",
                text: error.msg,
              });
            });
          }
          if (err.response.status == 401) {
            this.$notify({
              type: "error",
              title: "Authentication failed",
              text: err.response.data.message,
            });
            this.$router.push({ name: "AdminLogin" });
          }
        });
    },
    deleteItem() {
      this.$startLoader();
      this.$store
        .dispatch("DELETE_ARTWORK", {
          data: this.selectedItem,
          token: this.$getToken(),
        })
        .then((res) => {
          this.$stopLoader();
          if (res.data.status == "error") {
            this.$notify({
              type: "error",
              title: "Something went wrong",
              text: res.data.message,
            });
          } else {
            this.$notify({
              type: "success",
              title: "Success",
              text: res.data.message,
            });
            this.showDeleteModel = false;
            this.getItems();
          }
        })
        .catch((err) => {
          this.$stopLoader();
          if (err.response.status == 400) {
            err.response.data.errors.forEach((error) => {
              this.$notify({
                type: "error",
                title: "Something went wrong",
                text: error.msg,
              });
            });
          }
          if (err.response.status == 401) {
            this.$notify({
              type: "error",
              title: "Authentication failed",
              text: err.response.data.message,
            });
            this.$router.push({ name: "AdminLogin" });
          }
        });
    },
    filterItems() {
      if (this.filterCategory == "All") {
        this.items = this.allItems;
        this.changePage(1);
      } else {
        this.items = this.allItems.filter(
          (item) => item.artwork_status_eng == this.filterCategory
        );
      }
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
@import "@/assets/scss/dashboard.scss";
</style>